<div class="banner d-flex justify-content-between" [ngClass]="typeArray[type]">
  <div class="d-flex align-items-center justify-content-{{textDirection}} w-100" >
    <div class="icon">
      <svg-icon [stretch]="true" [src]="'assets/icons/' +  iconName + '.svg'"
      >
      </svg-icon>
    </div>
    <div>{{ label }} <span class="fs-13 fw-7 " *ngIf="boldText">{{ boldText }}</span></div>
  </div>
  <div class="text-primary cursor-pointer" *ngIf="withAction"
       (click)="handleClickAction()">{{ labelAction }}</div>
</div>
